import "pixi.js";
import "lodash";
import "gsap";
import GameModel from "../../vendor_core/core/src/model/GameModel";
import {
    HasRealityCheckCondition,
    ForceRealityCheckCondition,
} from "../../vendor_core/core/src/states/conditions/RealityCheckConditions";
import AwardedFreeGamesCondition from "../../vendor_core/states/conditions/AwardedFreeGamesCondition";
import RelaxFreeGamesAwardedState from "../../vendor_core/states/RelaxFreeGamesAwardedState";
import RoundFinish from "./states/BBRoundFinish";
import FullscreenUtils from "../../vendor_core/core/src/utils/FullscreenUtils";
import HTMLPopupsManager from "../../vendor_core/core/src/utils/HTMLPopupsManager";
import { HasCascadeCondition } from "../../vendor_core/core/src/states/conditions/HasCascadeCondition";
import AlwaysTrueCondition from "../../vendor_core/core/src/states/conditions/AlwaysTrueCondition";
import { HasAutoplayCondition } from "../../vendor_core/core/src/states/conditions/HasAutoplayCondition";
import { HasFreeSpinsCondition } from "../../vendor_core/core/src/states/conditions/HasFreeSpinsCondition";
import { IsInFreeSpinsCondition } from "../../vendor_core/core/src/states/conditions/IsInFreeSpinsCondition";
import App from "../../vendor_core/core/src/App";
import InstanceFactory from "../../vendor_core/core/src/factories/InstanceFactory";
import Assets from "../../vendor_core/core/src/utils/Assets";
import GameLoader from "../../vendor_core/core/src/utils/GameLoader";
import Layout from "../../vendor_core/core/src/utils/Layout";
import SoundController from "../../vendor_core/core/src/utils/SoundController";
import SymbolMap from "../../vendor_core/core/src/utils/SymbolMap";
import BBGameFactory from "./BBGameFactory";
import GameFactory from "./BBGameFactory";
import Utils from "../../vendor_core/core/src/utils/Utils";
import * as asset_config from "../configs/asset-config-main.json";
import * as debug_config from "../configs/debug-config.json";
import * as game_config from "../configs/game-config.json";
import * as state_config from "../configs/state-config.json";
import ViewManager from "../../vendor_core/core/src/utils/ViewManager";
import requestRegister from "../../vendor_core/core/src/server/requests/RequestRegister";
import stateMachine from "../../vendor_core/core/src/states/StateMachine";
import BBEnterFreespinState from "./states/BBEnterFreeSpinsState";
import BBExitFreespinsState from "./states/BBExitFreespinState";
import LoopLinesState from "../../vendor_core/core/src/states/LoopLinesState";
import { IStatesConfigSchema } from "../../vendor_core/core/src/states/State";
import VendorModel from "../../vendor_core/server/model/VendorModel";
import VendorDataParser from "../../vendor_core/server/parsers/VendorDataParser";
import BetModel from "../../vendor_core/core/src/model/BetModel";
import AutoplayModel from "../../vendor_core/core/src/model/AutoplayModel";
import SpinModel from "../../vendor_core/core/src/model/SpinModel";
import BBSpinDataParser from "./server/parsers/BBSpinDataParser";
import DebugMenu from "../../vendor_core/core/src/utils/DebugMenu";
import CommManager from "../../vendor_core/core/src/controllers/CommManager";

import * as SBRequests from "./server/requests/BBRequests";
import * as VendorRequests from "../../vendor_core/server/requests/Requests";
import ErrorModel from "../../vendor_core/core/src/model/ErrorModel";
import ErrorDataParser from "../../vendor_core/server/parsers/errorDataParser";
import ErrorState from "../../vendor_core/states/ErrorState";
import { HasErrorCondition } from "../../vendor_core/core/src/states/conditions/HasErrorCondition";
import UIController from "../../vendor_core/core/src/ui/UIController";
import BBTokenDataParser from "./server/parsers/BBTokenDataParser";
import BBSpinStartState from "./states/BBSpinStartState";
import BBSpinRequestState from "./states/BBSpinRequestState";
import RealityCheckModel from "../../vendor_core/core/src/model/RealityCheckModel";
import RealityCheckDataParser from "../../vendor_core/server/parsers/RealityCheckDataParser";
import RelaxPOSTMessageController from "../../vendor_core/server/RelaxPOSTMessageController";
import BBPreloadState from "./states/BBPreloadState";
import CommandManager from "../../vendor_core/core/src/commands/CommandManager";
import { Commands } from "../../vendor_core/core/src/commands/CommandEnum";
import * as GameCommands from "../../vendor_core/core/src/commands/GameCommands";
import * as VendorCommands from "../../vendor_core/src/commands/VendorCommands";
import ControllerManager from "../../vendor_core/core/src/utils/ControllerManager";
import EEEnterRecoverState from "../../vendor_core/states/EEEnterRecoverState";
import HasRecovery from "../../vendor_core/states/conditions/HasRecovery";
import { VendorCommandsEnum } from "../../vendor_core/src/commands/VendorCommandsEnum";
import InsufficientBalanceCondition from "../../vendor_core/states/conditions/InsufficientBalanceCondition";
import RelaxComm from "../../vendor_core/src/controllers/RelaxComm";
import BBLoginDataParser from "./server/parsers/BBLoginDataParser";
import { HasWinCondition } from "../../vendor_core/core/src/states/conditions/HasWinCondition";
import BBReelConfigParser from "./server/parsers/BBReelConfigParser";
import BBBigWinState from './states/BBBigWinState';
import { BBIdleState } from './states/BBIdleState';
import { BBHasBigWinCondition } from './states/conditions/BBHasBigWinCondition';
import { BBFreeSpinsWonCondition } from "./states/conditions/BBFreeSpinsWonCondition";
import BBHasLockedCondition from "./conditions/BBHasLockedCondition";
import BBShowWinState from "./states/BBShowWinState";
import BBCascadeState from "./states/BBCascadeState";
import BBModel from "./model/BBModel";
import BBMultipliersParser from './server/parsers/BBMultipliersParser';
import BBSpinEndState from "./states/BBSpinEndState";
import BBInsufficientBalanceState from './states/BBInsufficientBalanceState';
import BBHasCascadeLockedCondition from './conditions/BBHasCascadeLockedCondition';
import BBMoveCascadeSymbolState from './states/BBMoveCascadeSymbolState';
import BBHasMoveDataCondition from './conditions/BBHasMoveDataCondition';
import BBSpinResultState from './states/BBSpinResultState';
import BBCascadeOnSymPoppedState from './states/BBCascadeOnSymPoppedState';
import BBMoveSymbolState from './states/BBMoveSymbolState';
import BBParseMoveDataStateIco from './states/BBParseMoveDataStateIco';
import ConfigManager from '../../vendor_core/core/src/managers/ConfigManager'
import SpineAnimationConfig from '../configs/SpineAnimationsConfig';
import SymbolSpineAnimationConfig from '../configs/SymbolSpineAnimationsConfig';
import SettingsConfig from '../configs/SettingsConfig';
import SpineWinSymbolViewConfig from '../configs/SpineWinSymbolViewConfig';
import GameGeneralConfig from '../configs/GameGeneralConfig';
import BuyFeatureConfig from '../configs/BuyFeatureConfig';
import LocalConfig from '../configs/LocalConfig';
import BetConfig from '../configs/BetConfig';
import BBMessagePopup from './view/components/BBMessagePopup';
import BBErrorPopup from './view/components/BBErrorPopup';
import BBRealityCheckState from './states/BBRealityCheckState';
import BBAutoplayLimitPopup from './view/components/BBAutoplayLimitPopup';
import BBRelaxFreeGamesExitState from './states/BBRelaxFreeGamesExitState';
import BBHasFreeGamesExpiredCondition from './states/conditions/BBHasFreeGamesExpiredCondition';
import BBShouldExitFreeGamesCondition from './states/conditions/BBShouldExitFreeGamesCondition';
import BBBuyFeaturePopup from './view/components/BBBuyFeaturePopup';
import * as BBGameCommands from "./Commands/BBGameCommands";
import BBConfigDataParser from './server/parsers/BBConfigDataParser';
import ServerConfig from '../configs/ServerConfig';
import { ConfigurationTypes } from '../../vendor_core/core/src/const/ConfigurationTypes';

// TODO: polish this so we can easily see where each log comes from
// const _log = console.log;
// global.console.log = function () {
//   var traceobj = new Error("").stack.split("\n")[2].split(":");
//   let fullPath = traceobj[0];
//   let prefix = "";

//   if (fullPath.indexOf("/vendor_core/core/") != -1) {
//     prefix += "[CORE]";
//   } else if (fullPath.indexOf("/vendor_core/") != -1) {
//     prefix += "[VENDOR]";
//   }

//   let regex = fullPath.match(/\/.*?(\.ts|\.js)/gim);
//   if (regex && regex.length > 0) {
//     prefix +=
//       "[" +
//       regex[0].split("/").pop().replace(".ts", "").replace(".js", "") +
//       "]";
//   }

//   var new_args = [prefix];
//   new_args.push.apply(new_args, arguments);
//   _log.apply(null, new_args);
// };

// TODO - move this to some class
const urlParams: any = {};
declare const DEBUG: boolean;
location.search
    .substr(1)
    .split("&")
    .forEach((item) => {
        const tmp = item.split("=");
        if (tmp[0].length > 0) {
            urlParams[tmp[0]] = decodeURIComponent(tmp[1]);
        }
    });
console.log("version : ", urlParams.version);

const link = document.createElement("link");

link.rel = "stylesheet";
link.href = "./styles/main.css?version=" + urlParams.version;
document.getElementsByTagName("head")[0].appendChild(link);

// TODO THIS NEEDS A LOT OF REFACTORING
const start = (params) => {
    // let gameLoader = new GameLoader(urlParams);
    const gameConfig = params.config;

    GameModel.parseUrlParams(urlParams, gameConfig);
    GameLoader.loadFonts(gameConfig);
    // wait for fonts to load
    ConfigManager.registerConfigs([
        SpineAnimationConfig,
        SymbolSpineAnimationConfig,
        SpineWinSymbolViewConfig,
        BuyFeatureConfig,
        BetConfig,
        SettingsConfig,
        GameGeneralConfig,
        LocalConfig,
        ServerConfig
    ]);

    ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).parseParams(urlParams);

    window.onload = () => {
        const configs = GameModel.isMobile()
            ? asset_config.asset_configs.mobile
            : asset_config.asset_configs.desktop;
        GameLoader.loadConfig(configs, (loader) => {
            // GameModel.apiConfig = loader.resources.apiConfig.data;
            GameLoader.loadConfig(
                loader.resources.asset_config.data.layoutConfigurations,
                (loader) => {
                    const deviceWidth = Math.max(
                        window.screen.width,
                        window.screen.height
                    );
                    const START_WIDTH = Math.min(
                        deviceWidth,
                        loader.resources.layoutConfig.data.settings.nativeWidth
                    );
                    // const START_HEIGHT = loader.resources.layoutConfig.data.settings.nativeHeight;
                    //  const START_WIDTH = Math.max(window.screen.width, window.screen.height);
                    const START_HEIGHT = (START_WIDTH * 9) / 16;
                    console.log(START_WIDTH, START_HEIGHT);
                    CommManager.setComm(new RelaxComm());
                    registerRequests();
                    initDefaultCommands();
                    registerParsers();
                    InstanceFactory.init(new BBGameFactory());
                    HTMLPopupsManager.init(document.getElementById("content"));
                    const app = new App(
                        loader.resources.layoutConfig.data.settings
                    );
                    App.config = params.config;
                    Layout.init(START_WIDTH, START_HEIGHT);
                    GameModel.gameConfig = { ...game_config };
                    Utils.serialize(gameConfig, GameModel);
                    SymbolMap.init(GameModel.gameConfig.symbolResponseMap);
                    ControllerManager.init();
                    SoundController.init();
                    App.version = urlParams.version;
                    // Layout.init(START_WIDTH, START_HEIGHT);
                    App.assets = new Assets();
                    App.utils = new Utils();
                    App.dispatcher = new PIXI.utils.EventEmitter();
                    App.renderer = app.renderer;

                    window["ViewManager"] = ViewManager;
                    window["App"] = App;
                    window["Layout"] = Layout;
                    window["UI"] = UIController;
                    // ViewManager.init(layout_config, layerMap);
                    const mainLayoutData = loader.resources.layoutConfig.data;
                    const secondaryData = loader.resources.secondaryLayoutConfig
                        ? loader.resources.secondaryLayoutConfig.data
                        : null;
                    ViewManager.init(
                        mainLayoutData,
                        loader.resources.layerMap.data,
                        secondaryData
                    );
                    window.onresize = onResize;
                    FullscreenUtils.init(onResize);
                    document
                        .getElementById(params.config.container_name)
                        .appendChild(app.view);
                    app.view.style.zIndex = params.config.canvas_zIndex;
                    onResize();
                    registerStates();
                    setUpUIComponents();
                    if (DEBUG) {
                        createDebugMenu();
                    }

                    //PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.NEAREST;

                    RelaxPOSTMessageController.initializeAPI();

                    function disposeBootLoader() {
                        // app.stage.removeChild(preCacher);
                        // // preCacher.destroy();
                        // if (preloadView) {
                        //     app.stage.removeChild(preloadView);
                        //     preloadView = null;
                        // } else {
                        //     // app.stage.removeChild(loadBar);
                        //     // loadBar = null;
                        //     // app.stage.removeChild(loadBarBg);
                        //     // loadBarBg = null;
                        //     // app.stage.removeChild(splashBg);
                        //     // splashBg = null;
                        //     app.dispatcher.emit(GameEvents.END_LOADING);
                        // }
                        // todo - check which assets can be cleaned from bootLoader
                    }

                    // TODO Move this somewhere
                    function onResize() {
                        const scale = "scale(1)";
                        document.body.style.webkitTransform = scale; // Chrome, Opera, Safari
                        // document.body.style.msTransform = scale;        // IE 9 //TODO
                        document.body.style.transform = scale; // General

                        const vpWidth = window.innerWidth;
                        const vpHeight = window.innerHeight;

                        console.log(
                            "innerWidth : " +
                            window.innerWidth +
                            " innerHeight : " +
                            window.innerHeight
                        );

                        const landscape = vpWidth > vpHeight;

                        let scaleFactor;
                        let newWidth;
                        let newHeight;

                        scaleFactor = Math.min(
                            vpWidth / START_WIDTH,
                            vpHeight / START_HEIGHT
                        );
                        newWidth = vpWidth;
                        newHeight = vpHeight;

                        console.log(
                            "Resizing to w:" +
                            newWidth +
                            " h:" +
                            newHeight +
                            " scaleFactor:" +
                            scaleFactor
                        );

                        newWidth = Math.ceil(newWidth);
                        newHeight = Math.ceil(newHeight);

                        app.renderer.resize(
                            newWidth / scaleFactor,
                            newHeight / scaleFactor
                        );
                        app.stage.scale.set(scaleFactor);
                        app.stage.scale.set(1);
                        Layout.onResize(newWidth, newHeight);
                        app.renderer.view.style.width = `${newWidth}px`;
                        app.renderer.view.style.height = `${newHeight}px`;
                    }

                    function registerRequests() {
                        requestRegister.add(
                            "authorize",
                            new SBRequests.BBTokenRequest()
                        );
                        requestRegister.add(
                            "getclientconfig",
                            new VendorRequests.ClientConfigRequest()
                        );
                        requestRegister.add(
                            "getclientconfigURL",
                            new VendorRequests.ClientConfigURLRequest()
                        );
                        requestRegister.add(
                            "tokenRequest",
                            new SBRequests.BBTokenRequest()
                        );
                        requestRegister.add(
                            "loginRequest",
                            new SBRequests.BBLoginRequest()
                        );
                        requestRegister.add(
                            "funLoginRequest",
                            new SBRequests.SBoFunLoginRequest()
                        );
                        requestRegister.add(
                            "refreshRequest",
                            new SBRequests.BBRefreshRequest()
                        );
                        requestRegister.add(
                            "sessionResult",
                            new VendorRequests.GetSessionRequest()
                        );
                        requestRegister.add(
                            "playRequest",
                            new SBRequests.BBPlayRequest()
                        );
                        requestRegister.add(
                            "scenarioRequest",
                            new SBRequests.BBScenarioRequest()
                        );
                        requestRegister.add(
                            "saveSettingsRequest",
                            new VendorRequests.SaveSettingsRequest()
                        );
                        requestRegister.add(
                            "historyRequest",
                            new VendorRequests.ReplayRequest()
                        );
                        requestRegister.add(
                            "skipFreeGames",
                            new VendorRequests.SkipFreeGamesRequest()
                        );
                        requestRegister.add(
                            "cancelFreeGames",
                            new VendorRequests.CancelFreeGamesRequest()
                        );
                        requestRegister.add(
                            "hasFreeGames",
                            new VendorRequests.HasFreeGamesRequest()
                        );
                        requestRegister.add(
                            "saveRestoreState",
                            new VendorRequests.SaveRestoreStateRequest()
                        );
                        requestRegister.add(
                            "finishRound",
                            new VendorRequests.FinishRound()
                        );
                        requestRegister.add(
                            "setRealityCheckLimits",
                            new VendorRequests.SetRealityCheckLimits()
                        );
                        requestRegister.add(
                            "resetRealityCheck",
                            new VendorRequests.ResetRealityCheck()
                        );
                        requestRegister.add(
                            "getBalance",
                            new VendorRequests.GetBalanceRequest()
                        );
                    }

                    function initDefaultCommands() {
                        CommandManager.setCommand(
                            Commands.UPDATE_UI,
                            GameCommands.UpdateUICommand
                        );
                        CommandManager.setCommand(
                            Commands.SPIN,

                            BBGameCommands.SpinCommand
                        );
                        CommandManager.setCommand(
                            Commands.SKIP,
                            GameCommands.SkipCommand
                        );

                        CommandManager.setCommand(
                            Commands.TOGGLE_SPACE_TO_SPIN,
                            GameCommands.ToggleSpaceToSpinCommand
                        );
                        CommandManager.setCommand(
                            Commands.TOGGLE_TURBO_SPIN,
                            GameCommands.ToggleTuboSpinCommand
                        );

                        CommandManager.setCommand(
                            Commands.START_AUTOPLAY,
                            BBGameCommands.StartAutoplayCommand
                        );
                        CommandManager.setCommand(
                            Commands.STOP_AUTOPLAY,
                            BBGameCommands.StopAutoplayCommand
                        );
                        CommandManager.setCommand(
                            Commands.UPDATE_BALANCE,
                            VendorCommands.makeBalanceRequest
                        );
                        CommandManager.setCommand(
                            Commands.DECREMENT_AUTOPLAY,
                            BBGameCommands.DecrementAutoplay
                        );
                        CommandManager.setCommand(
                            Commands.CLEAR_AUTOPLAY_LIMITS,
                            GameCommands.ClearAutoplayLimitsCommand
                        );
                        CommandManager.setCommand(
                            Commands.SET_AUTOPLAY_LOSS_LIMIT,
                            GameCommands.SetAutoplayLossLimitCommand
                        );
                        CommandManager.setCommand(
                            Commands.SET_AUTOPLAY_SINGLE_WIN_LIMIT,
                            GameCommands.SetAutoplaySingleWinLimitCommand
                        );
                        CommandManager.setCommand(
                            Commands.SET_AUTOPLAY_TOTAL_WIN_LIMIT,
                            GameCommands.SetAutoplayTotalWinLimitCommand
                        );
                        CommandManager.setCommand(
                            Commands.TOGGLE_AUTOPLAY_STOP_ON_ANY_WIN,
                            GameCommands.ToggleAutoplayStopOnWinCommand
                        );
                        CommandManager.setCommand(
                            Commands.TOGGLE_AUTOPLAY_STOP_ON_FEATURE_WIN,
                            GameCommands.ToggleAutoplayStopOnFeatureCommand
                        );

                        CommandManager.setCommand(
                            Commands.CLOSE_SETTINGS,
                            GameCommands.CloseSettingsCommand
                        );

                        CommandManager.setCommand(
                            Commands.CYCLE_STAKE_VALUE,
                            GameCommands.IterateStakeCommand
                        );
                        CommandManager.setCommand(
                            Commands.CYCLE_BET_VALUE,
                            GameCommands.IterateBetCommand
                        );
                        CommandManager.setCommand(
                            Commands.SET_BET,
                            VendorCommands.SetBetCommand
                        );
                        CommandManager.setCommand(
                            Commands.UPDATE_FREE_SPINS,
                            GameCommands.UpdateFreeSpinsCommand
                        );
                        CommandManager.setCommand(
                            Commands.GO_HOME,
                            VendorCommands.GoHome
                        );
                        CommandManager.setCommand(
                            Commands.OPEN_RC_HISTORY,
                            VendorCommands.OpenRCHistory
                        );
                        CommandManager.setCommand(
                            Commands.SAVE_SETTINGS,
                            GameCommands.SaveSettingsCommand
                        );
                        CommandManager.setCommand(
                            Commands.SET_MAX_BET,
                            GameCommands.SetMaxBetCommand
                        );
                        CommandManager.setCommand(
                            Commands.CYCLE_COIN_VALUE,
                            GameCommands.IterateCoinsCommand
                        );
                        CommandManager.setCommand(
                            Commands.CYCLE_TOTAL_BET,
                            GameCommands.IterateTotalBetCommand
                        );

                        CommandManager.setCommand(
                            Commands.TOGGLE_SETTINGS,
                            GameCommands.ToggleSettingsCommand
                        );
                        CommandManager.setCommand(
                            Commands.TOGGLE_AUTOPLAY_SETTINGS,
                            GameCommands.ToggleAutoplaySettingsCommand
                        );
                        CommandManager.setCommand(
                            Commands.TOGGLE_BET_SETTINGS,
                            GameCommands.ToggleBetSettingsCommand
                        );
                        CommandManager.setCommand(
                            Commands.TOGGLE_PAYTABLE,
                            GameCommands.TogglePaytableCommand
                        );
                        CommandManager.setCommand(
                            Commands.TOGGLE_AUTOPLAY_POPUP,
                            GameCommands.ToggleAutoplayPopupCommand
                        );
                        CommandManager.setCommand(
                            Commands.TOGGLE_BET_POPUP,
                            GameCommands.ToggleBetPopupCommand
                        );

                        CommandManager.setCommand(
                            Commands.TOGGLE_SOUND_FX,
                            GameCommands.ToggleSoundFXCommand
                        );
                        CommandManager.setCommand(
                            Commands.TOGGLE_MUSIC,
                            GameCommands.ToggleMusicCommand
                        );
                        CommandManager.setCommand(
                            Commands.TOGGLE_MASTER_SOUND,
                            BBGameCommands.ToggleMasterSoundCommand
                        );
                        CommandManager.setCommand(
                            Commands.SET_MASTER_VOLUME,
                            GameCommands.SetMasterVolumeCommand
                        );

                        CommandManager.setCommand(
                            Commands.UPDATE_TEMP_WIN,
                            GameCommands.UpdateTempWinCommand
                        );
                        CommandManager.setCommand(
                            Commands.UPDATE_WIN,
                            GameCommands.UpdateWinCommand
                        );
                        CommandManager.setCommand(
                            Commands.CLEAR_WIN,
                            GameCommands.ClearWinFieldCommand
                        );
                        CommandManager.setCommand(
                            Commands.SHOW_ERROR,
                            GameCommands.ShowErrorPopup
                        );
                        CommandManager.setCommand(
                            Commands.REQUEST_HISTORY,
                            VendorCommands.RequestHistory
                        );
                        CommandManager.setCommand(
                            Commands.SHOW_HISTORY,
                            VendorCommands.ShowHistoryPage
                        );
                        CommandManager.setCommand(
                            Commands.HIDE_HISTORY,
                            VendorCommands.HideHistoryPage
                        );
                        CommandManager.setCommand(
                            VendorCommandsEnum.CANCEL_FREE_GAMES,
                            VendorCommands.CancelFreeSpins
                        );
                        CommandManager.setCommand(
                            VendorCommandsEnum.SKIP_FREE_GAMES,
                            VendorCommands.SkipFreeSpins
                        );
                        CommandManager.setCommand(
                            VendorCommandsEnum.TOGGLE_BUY_FEATURE,
                            VendorCommands.ShowBuyFeaturePopup
                        );
                        CommandManager.setCommand(
                            VendorCommandsEnum.FEATURE_BYE_SPIN,
                            VendorCommands.BuyFeatureSpin
                        );
                    }

                    function registerParsers() {
                        const loginDataParser = new BBLoginDataParser();
                        GameModel.registerParser(new BBConfigDataParser());
                        GameModel.registerParser(new BBTokenDataParser());
                        GameModel.registerParser(new BBSpinDataParser());
                        GameModel.registerParser(loginDataParser);
                        BetModel.registerParser(loginDataParser);
                        BetModel.registerParser(new BBSpinDataParser());
                        // BetModel.registerParser(loginDataParser);
                        // AutoplayModel.registerParser(new AutoplayDataParser());
                        // spinModel.registerParser(new SpinDataParser());
                        BBModel.registerParser(new BBMultipliersParser());
                        SpinModel.registerParser(new BBReelConfigParser());
                        SpinModel.registerParser(new BBSpinDataParser());
                        ErrorModel.registerParser(new ErrorDataParser());
                        RealityCheckModel.registerParser(
                            new RealityCheckDataParser()
                        );
                        VendorModel.registerParser(new VendorDataParser());
                    }

                    AutoplayModel.parseConfig(gameConfig)

                    function createDebugMenu() {
                        const debugMenu = new DebugMenu(
                            document.getElementById("content")
                        );
                        debugMenu.addDebugInput("Custom");
                        debug_config.forEach((element) => {
                            debugMenu.addDebugCase(
                                element.name,
                                element.data,
                                (element as any).special
                            );
                        });
                        debugMenu.menu.style.zIndex =
                            params.config.canvas_zIndex + 1;
                    }

                    function registerStates() {
                        stateMachine.registerState(
                            "preload",
                            new BBPreloadState(stateMachine)
                        );
                        stateMachine.registerState(
                            "idle",
                            new BBIdleState(stateMachine)
                        );
                        stateMachine.registerState(
                            "spin",
                            new BBSpinStartState(stateMachine)
                        );
                        stateMachine.registerState(
                            "spin_request",
                            new BBSpinRequestState(stateMachine)
                        );
                        stateMachine.registerState(
                            "spin_result",
                            new BBSpinResultState(stateMachine)
                        );
                        stateMachine.registerState(
                            "spin_end",
                            new BBSpinEndState(stateMachine)
                        );
                        stateMachine.registerState(
                            "show_win",
                            new BBShowWinState(stateMachine)
                        );
                        stateMachine.registerState(
                            "show_big_win",
                            new BBBigWinState(stateMachine)
                        );
                        stateMachine.registerState(
                            "loop_lines",
                            new LoopLinesState(stateMachine)
                        );
                        stateMachine.registerState(
                            "move_wilds",
                            new BBMoveSymbolState(stateMachine)
                        );
                        stateMachine.registerState(
                            "move_locked_wilds_in_cascade",
                            new BBMoveCascadeSymbolState(stateMachine)
                        );
                        // stateMachine.registerState(
                        //     "unlock_locked_wilds_in_cascade",
                        //     new BBUnlockCascadeWildsState(stateMachine)
                        // );
                        stateMachine.registerState(
                            "parse_move_wild_data",
                            new BBParseMoveDataStateIco(stateMachine)
                        );
                        // stateMachine.registerState(
                        //     "lock_cascade_symbols",
                        //     new BBLockCascadeSymbolState(stateMachine)
                        // );
                        stateMachine.registerState(
                            "error",
                            new ErrorState(stateMachine)
                        );
                        stateMachine.registerState(
                            "reality_check",
                            new BBRealityCheckState(stateMachine)
                        );
                        stateMachine.registerState(
                            "finish",
                            new RoundFinish(stateMachine)
                        );
                        stateMachine.registerState(
                            "recover",
                            new EEEnterRecoverState(stateMachine)
                        );
                        stateMachine.registerState(
                            "freeGamesAward",
                            new RelaxFreeGamesAwardedState(stateMachine)
                        );
                        stateMachine.registerState(
                            "enter_freespins",
                            new BBEnterFreespinState(stateMachine)
                        );
                        stateMachine.registerState(
                            "exit_freespins",
                            new BBExitFreespinsState(stateMachine)
                        );
                        stateMachine.registerState(
                            "exitFreeGames",
                            new BBRelaxFreeGamesExitState(stateMachine)
                        );
                        stateMachine.registerState(
                            "cascade_respin",
                            new BBCascadeState(stateMachine)
                        );
                        stateMachine.registerState(
                            "cascade_respin_on_sym_popped",
                            new BBCascadeOnSymPoppedState(stateMachine)
                        );
                        stateMachine.registerState(
                            "insufficientBalance",
                            new BBInsufficientBalanceState(stateMachine)
                        );
                        // stateMachine.registerState(
                        //     "locked",
                        //     new BBLockSymbolState(stateMachine)
                        // );

                        stateMachine.registerCondition(
                            "default",
                            new AlwaysTrueCondition()
                        );
                        // stateMachine.registerCondition(
                        //     "hasMovingWilds",
                        //     new BBHasMovingCondition()
                        // );
                        stateMachine.registerCondition(
                            "has_move_wild_data_in_cascade",
                            new BBHasMoveDataCondition()
                        );
                        stateMachine.registerCondition(
                            "hasLocked",
                            new BBHasLockedCondition()
                        );
                        stateMachine.registerCondition(
                            "has_cascade_locked_symbols",
                            new BBHasCascadeLockedCondition()
                        );
                        stateMachine.registerCondition(
                            "hasBigWin",
                            new BBHasBigWinCondition()
                        );
                        stateMachine.registerCondition(
                            "hasWin",
                            new HasWinCondition()
                        );
                        stateMachine.registerCondition(
                            "hasCascadeRespin",
                            new HasCascadeCondition()
                        );
                        stateMachine.registerCondition(
                            "hasAutoplay",
                            new HasAutoplayCondition()
                        );
                        stateMachine.registerCondition(
                            "freespinsWon",
                            new BBFreeSpinsWonCondition()
                        );
                        stateMachine.registerCondition(
                            "hasFreespins",
                            new HasFreeSpinsCondition()
                        );
                        stateMachine.registerCondition(
                            "inFreespins",
                            new IsInFreeSpinsCondition()
                        );
                        stateMachine.registerCondition(
                            "hasError",
                            new HasErrorCondition()
                        );
                        stateMachine.registerCondition(
                            "hasRealityCheck",
                            new HasRealityCheckCondition()
                        );
                        stateMachine.registerCondition(
                            "forceRealityCheck",
                            new ForceRealityCheckCondition()
                        );
                        stateMachine.registerCondition(
                            "hasRecover",
                            new HasRecovery()
                        );
                        stateMachine.registerCondition(
                            "awardedFreeGames",
                            new AwardedFreeGamesCondition()
                        );
                        stateMachine.registerCondition(
                            "insufficientBalanceCondition",
                            new InsufficientBalanceCondition()
                        );

                        stateMachine.registerCondition(
                            "shouldExitFreeGames",
                            new BBShouldExitFreeGamesCondition()
                        );
                        stateMachine.registerCondition(
                            "HasFreeGamesExpired",
                            new BBHasFreeGamesExpiredCondition()
                        );
                        stateMachine.startStateMachine(
                            state_config as IStatesConfigSchema
                        );
                    }

                    function setUpUIComponents() {
                        UIController.setComponent(
                            "main",
                            InstanceFactory.getClass("UIView")
                        );
                        UIController.setComponent(
                            "settings",
                            InstanceFactory.getClass("Settings")
                        );
                        // UIController.setComponent('autoplayPopup', InstanceFactory.getClass('AutoplayPopup'));
                        UIController.setComponent(
                            "autoplayLimitPopup",
                            new BBAutoplayLimitPopup()
                        );
                        if (GameModel.gameConfig.featureBye) {
                            UIController.setComponent(
                                "buyFeature",
                                new BBBuyFeaturePopup()
                            );
                        }

                        UIController.setComponent(
                            "errorPopup",
                            new BBErrorPopup()
                        );
                        UIController.setComponent(
                            "messagePopup",
                            new BBMessagePopup()
                        );
                    }
                }
            );
        });

        // Populate requests
    };
};

start({ config: game_config, gameFactory: new GameFactory() });
